import { UIActions, UIActionType } from '../actions/uiActions';
import { OpenedFrom } from '@/lib/gTagManager';

export interface UIState {
  isSingleGame: boolean;
  registrationOpenedFrom: OpenedFrom | null;
  loginOpenedFrom: OpenedFrom | null;
}

const initialState = {
  isSingleGame: false,
  registrationOpenedFrom: null,
  loginOpenedFrom: null,
};

export const uiReducer = (state = initialState, action: UIActions): UIState => {
  switch (action.type) {
    case UIActionType.SetIsSingleGame:
      return {
        ...state,
        isSingleGame: action.isSingleGame,
      };
    case UIActionType.SetRegistrationOpenedFrom:
      return {
        ...state,
        registrationOpenedFrom: action.openedFrom,
      };
    case UIActionType.SetLoginOpenedFrom:
      return {
        ...state,
        loginOpenedFrom: action.openedFrom,
      };
    default:
      return state;
  }
};
